module.exports = __webpack_public_path__ + "img/IMG_1368.d2acc7ea.jpg";